import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getSetupActionModalOpen = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement?.setupActionModalOpen ?? false;
  }
);
